import React from 'react';
import { Grid } from '@mui/material';
import SwpCalculatorForm from '../components/SwpCalculatorForm';
import CalculatorSidebar from '../components/CalculatorSidebar';

const SwpCalculatorPage: React.FC = () => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <SwpCalculatorForm />
      </Grid>
      <Grid item xs={12} md={4} sx={{ display: { xs: 'none', md: 'block' } }}>
        <CalculatorSidebar />
      </Grid>
    </Grid>
  );
};

export default SwpCalculatorPage;
